// src/app/guards/user.guard.ts
import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {EmployeeService} from '@/app/domains/auth/employee/data-access/employee.service';
import {getApps, getApp, initializeApp} from 'firebase/app';
import {environment} from '@/environments/environment';

function ensureFirebaseApp(): void {
    const apps = getApps();
    if (!apps.length) initializeApp(environment.firebase);
    else getApp();
}

@Injectable({providedIn: 'root'})
export class UserGuard implements CanActivate {
    constructor(
        private employeeService: EmployeeService,
        private router: Router
    ) {
    }

    async canActivate(): Promise<boolean | UrlTree> {
        try {
            ensureFirebaseApp();

            // Login sin terminar (no eligió modo/sucursal): el token no tiene
            // scope — volver al login, que descarta la sesión.
            if (await this.employeeService.isLoginPending()) {
                return this.router.parseUrl('/login');
            }

            // 1) Primero: token del microservicio AUTH
            const backendValid = await this.employeeService.backendTokenIsValid();
            console.log('[UserGuard] backendToken válido:', backendValid);
            if (backendValid) return true;

            // 2) Fallback: token ERP/monolito
            const valid = await this.employeeService.tokenIsValid();
            console.log('[UserGuard] Token ERP válido:', valid);

            return valid ? true : this.router.parseUrl('/login');
        } catch (error) {
            console.error('[UserGuard] Error verificando token:', error);
            return this.router.parseUrl('/login');
        }
    }
}
